import { deleteCookiesByName } from "../scripts/helpers"

const clearVehicleBtns = document.getElementsByClassName(
  "clear-vehicle-button"
);
let isVehicleRemoveClicked = false;
for (let index = 0; index < clearVehicleBtns.length; index++) {
  const btn = clearVehicleBtns[index];
  btn.addEventListener("click", async () => {
    if (isVehicleRemoveClicked) {
      return;
    }

    deleteCookiesByName('vehicle')
    isVehicleRemoveClicked = true
    const newURL = new URL(window.location.href);
    const newSearchParams = new URLSearchParams(window.location.search);
    newSearchParams.delete('vYear')
    newSearchParams.delete('vMake')
    newSearchParams.delete('vModel')
    newSearchParams.delete('vTrim')
    newURL.search = newSearchParams
    window.location.href = newURL
  });
}
